import { Grid, Typography } from "@mui/material";
import React from "react";
import { InputTypes } from "../../../../constants/enums";
import Form from "../../../../components/UI/Form/Form";
import MuiButton from "../../../../components/UI/MuiButton";
import { IFormField } from "../../../../models/app";

interface Props {
  onChange: (name: string, value: any) => void;
  onSubmit: (data: any) => void;
}

const LoginForm: React.FC<Props> = ({ onChange, onSubmit }) => {
  const basicFields: IFormField[] = [
    {
      name: "email",
      label: "Email",
      type: InputTypes.TEXT
    },
    {
      name: "password",
      label: "Password",
      type: InputTypes.PASSWORD
    }
  ];

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter") {
      event.preventDefault();
      onSubmit({}); // Provide any necessary data here if needed
    }
  };

  return (
    <div onKeyDown={handleKeyDown}>
      <div style={{ display: 'flex', alignItems: 'end' }}>
        <Form
          fields={basicFields}
          onChange={onChange}
        />
      </div>
      <Typography variant="subtitle2" style={{ marginBlock: "5px", textAlign: 'center' }}>
        Use your credentials to access your account.
      </Typography>
      <Grid container justifyContent="center" sx={{ py: 2 }}>
        <MuiButton
          size="large"
          variant="contained"
          type="submit"
          sx={{ minWidth: 184 }}
          onClick={() => onSubmit({})}
        >
          Login
        </MuiButton>
      </Grid>
    </div>
  );
};

export default LoginForm;
